import { FieldTypes } from './formField/FieldTypeMapping';
import FormTypes from './formDefinition/FormTypes';
import { FormFieldPropertyObjectTypesIds } from './PropertyObjectTypes';
export const ContactProperties = {
  firstname: 'firstname',
  lastname: 'lastname',
  email: 'email',
  phone: 'phone',
  address: 'address',
  city: 'city',
  state: 'state',
  country: 'country',
  mobilephone: 'mobilephone',
  company: 'company'
};
export const ContactPropertiesOrder = {
  [ContactProperties.firstname]: 0,
  [ContactProperties.lastname]: 1,
  [ContactProperties.email]: 2,
  [ContactProperties.phone]: 3,
  [ContactProperties.address]: 4,
  [ContactProperties.city]: 5,
  [ContactProperties.state]: 6,
  [ContactProperties.country]: 7,
  [ContactProperties.mobilephone]: 8,
  [ContactProperties.company]: 9
};
export const FieldTypesWithOptions = {
  [FieldTypes.SELECT]: [FieldTypes.SELECT],
  [FieldTypes.RADIO]: [FieldTypes.RADIO],
  [FieldTypes.CHECKBOX]: [FieldTypes.CHECKBOX]
};
export const TicketProperties = {
  SUBJECT: 'subject',
  CONTENT: 'content',
  CATEGORY: 'hs_ticket_category',
  FILE_UPLOAD: 'hs_file_upload',
  PRIORITY: 'hs_ticket_priority',
  RESOLUTION: 'hs_resolution',
  SOURCE: 'source_type'
};
export const TicketPropertiesOrder = {
  [TicketProperties.CATEGORY]: 0,
  [TicketProperties.FILE_UPLOAD]: 1,
  [TicketProperties.PRIORITY]: 2,
  [TicketProperties.RESOLUTION]: 3,
  [TicketProperties.SOURCE]: 4,
  [TicketProperties.SUBJECT]: 5,
  [TicketProperties.CONTENT]: 6
};
export const BlogCommentProperties = {
  COMMENT: 'comment'
};
export const UnknownProperties = {
  PAYMENT_LINK: 'payment_link_id'
};
export const requiredTicketPropertiesForConversations = [TicketProperties.SUBJECT, TicketProperties.CONTENT];
export const MandatoryProperties = {
  [FormTypes.TICKET_FORM]: {
    [FormFieldPropertyObjectTypesIds.TICKET]: [TicketProperties.SUBJECT, TicketProperties.CONTENT],
    [FormFieldPropertyObjectTypesIds.CONTACT]: [ContactProperties.email],
    [FormFieldPropertyObjectTypesIds.COMPANY]: [],
    [FormFieldPropertyObjectTypesIds.UNKNOWN]: []
  },
  [FormTypes.BLOG_COMMENT]: {
    [FormFieldPropertyObjectTypesIds.CONTACT]: [BlogCommentProperties.COMMENT],
    [FormFieldPropertyObjectTypesIds.COMPANY]: [],
    [FormFieldPropertyObjectTypesIds.TICKET]: [],
    [FormFieldPropertyObjectTypesIds.UNKNOWN]: []
  },
  [FormTypes.HUBSPOT]: {
    [FormFieldPropertyObjectTypesIds.UNKNOWN]: [UnknownProperties.PAYMENT_LINK],
    [FormFieldPropertyObjectTypesIds.CONTACT]: [],
    [FormFieldPropertyObjectTypesIds.COMPANY]: [],
    [FormFieldPropertyObjectTypesIds.TICKET]: []
  }
};
export const NonRemovableProperties = Object.assign({}, MandatoryProperties, {
  [FormTypes.HUBSPOT]: {
    [FormFieldPropertyObjectTypesIds.TICKET]: [TicketProperties.SUBJECT, TicketProperties.CONTENT],
    [FormFieldPropertyObjectTypesIds.CONTACT]: [],
    [FormFieldPropertyObjectTypesIds.COMPANY]: [],
    [FormFieldPropertyObjectTypesIds.UNKNOWN]: []
  }
});
export const HiddenPropertyNames = [...Object.values(UnknownProperties)];